import type { Game } from '../../stores/game/types';

// A game on the provider jackpot feed — its tile draws the feed's balance bar across the top.
export const isJackpotGame = ({ moreDetails }: Game): boolean =>
  typeof moreDetails === 'object' && 'jackpotFeedGC' in Object(moreDetails);
